import { checkForAccess } from 'rp-navigation';
import browserHistory from '../index';

const showBarrier = (event, url) => {
    event.preventDefault();

    const urlToRedirect = `${window.location.origin}/profile/${url.split('#')[0]}`;
    const lightBoxText =
        "Subscribe to Members' Club and get access to this content and much more";

    checkForAccess('Subscriptions', true, true,
        {
            text: lightBoxText,
            r: urlToRedirect,
            service: 'both',
        }).then((hasAccess) => {
            if (hasAccess) {
                browserHistory.push(url);
            }
        });
};

export default showBarrier;



// WEBPACK FOOTER //
// ./src/js/utils/showBarrier.js